export class ApiInvoice {
    data = {
        "id": null,
    };

    constructor(public data1: any) {
        this.data = data1;
    }

    prefix = "apiInvoice";
    title = "apiInvoice";
    fields = ["shortName", "lineMemo", "refDate", "balance"];
    dataFields = {
        id: {'title': 'id', 'value': null, 'type': 'number', 'readonly': true},
        'n': {'title': 'invoice_n', 'value': null, 'type': 'number', 'readonly': true},
        'jurnID': {'title': 'jurnID', 'value': null, 'type': 'text', 'readonly': true},
        'lineID': {'title': 'lineID', 'value': null, 'type': 'number', 'readonly': true},
        'shortName': {'title': 'invoiceShortName', 'value': null, 'type': 'text'},
        'refDate': {'title': 'refDate', 'value': null, 'type': 'date'},
        'dueDate': {'title': 'dueDate', 'value': null, 'type': 'date'},
        'comment': {'title': 'comment', 'value': null, 'type': 'text'},
        'transType': {'title': 'transType', 'value': null, 'type': 'text'},
        'docStatus': {'title': 'docStatus', 'value': null, 'type': 'text'},
        'ref1': {'title': 'ref1', 'value': null, 'type': 'text'},
        'lineMemo': {'title': 'transType', 'value': null, 'type': 'text'},
        'isPDF': {'title': 'PDF', 'value': null, 'type': 'boolean'},
        'debit': {'title': 'debit', 'value': null, 'type': 'number', 'readonly': true},
        'credit': {'title': 'credit', 'value': null, 'type': 'number', 'readonly': true},
        'balance': {'title': 'invoiceBalance', 'value': null, 'type': 'number', 'readonly': true},


        'qtyCat': {'title': 'qtyCat', 'value': null, 'type': 'text'},
        'salesCurMonth': {'title': 'salesCurMonth', 'value': null, 'type': 'number'},
        'salesPrevMonth': {'title': 'salesPrevMonth', 'value': null, 'type': 'number'},
        'salesBef2Month': {'title': 'salesBef2Month', 'value': null, 'type': 'number'},
        'salesBef3Month': {'title': 'salesBef3Month', 'value': null, 'type': 'number'},



    }
}